module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dy-item-wrap', {
    ref: "formItemWrap",
    attrs: {
      "item": _vm.item
    }
  }, [_c('el-cascader', _vm._g(_vm._b({
    attrs: {
      "disabled": _vm.item.disabled || false,
      "options": _vm.item.options,
      "filterable": "",
      "clearable": "",
      "props": {
        expandTrigger: 'hover',
        multiple: !!_vm.item.isMultiple,
        emitPath: !_vm.item.single,
        checkStrictly: !!_vm.item.checkStrictly
      }
    }
  }, 'el-cascader', _vm.$attrs, false), _vm.$listeners))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d36ad10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicForm/widgets/CascaderWidget.vue
// module id = 709
// module chunks = 20